/* eslint-disable */
import React from 'react';
import ReactModal from 'react-modal';
import { RegularButton, AlertAdapter } from 'pg-ui-library';
import { CloseIcon } from 'src/modules/login/components/mfa-modal/styles';
import closeSvg from 'src/assets/close.svg';
import { useProcessPay } from '../mutations/expense.mutation';
import { DateTime } from 'luxon';

type ProcessPayQuery = {
  status: string[];
  employeeName?: string;
  hireType?: string;
  supplierName?: string;
  expenseShowId?: string;
  dateCriteria?: 'period';
  dateFilterType?: string;
  fromDate?: string | null;
  toDate?: string | null;
};

export const ProcessPayModal: React.FC<{
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  totalExpenses: number;
  filters?: any;
}> = ({ isOpen, setIsOpen, totalExpenses, filters }) => {
  const processPay = useProcessPay();

  const handleClose = () => setIsOpen(false);

  // ---- Build the query for pay processing
  const buildPayQuery = (): ProcessPayQuery => {
    const { fromDate, toDate } = getApiDateParams();

    const query: ProcessPayQuery = {
      // ALWAYS enforce bill_processed unless user filters differently
      status: filters?.status && filters.status !== '' ? [filters.status] : ['bill_processed'],

      employeeName: filters?.employeeName || undefined,
      hireType: filters?.hireType || undefined,
      supplierName: filters?.supplierName || undefined,
      expenseShowId: filters?.expenseShowId || undefined,
      //   clientName: filters?.clientName || undefined,
      dateCriteria: 'period',
      dateFilterType: filters?.dateRangeType || undefined,
      fromDate,
      toDate,
    };

    return Object.fromEntries(
      Object.entries(query).filter(([_, v]) => v !== null && v !== '' && v !== undefined)
    ) as ProcessPayQuery;
  };

  const handleConfirm = async () => {
    try {
      const response = await processPay.mutateAsync({
        action: 'PROCESS_PAYMENT',
        query: buildPayQuery(),
      });

      AlertAdapter('Pay batch processed successfully!', 'success');

      if (response?.downloadUrl) {
        const link = document.createElement('a');
        link.href = response.downloadUrl;
        link.download = `${response.batchCode}.zip`;
        link.click();
      }

      handleClose();
    } catch (e) {
      // handle mutation errors
    }
  };

  const formatDateForApi = (date: Date | null) => {
    if (!date) return null;
    return DateTime.fromJSDate(date).toFormat('yyyy-MM-dd');
  };

  // const getApiDateParams = () => {
  //   if (!filters) return { startDate: null, endDate: null };

  //   const start = filters.startDate ? formatDateForApi(filters.startDate) : null;
  //   const end = filters.endDate ? formatDateForApi(filters.endDate) : null;

  //   switch (filters.dateRangeType) {
  //     case 'after':
  //       return { startDate: start, endDate: null };
  //     case 'before':
  //       return { startDate: null, endDate: end };
  //     case 'between':
  //       return { startDate: start, endDate: end };
  //     case 'exactly':
  //       return { startDate: start, endDate: start };
  //     default:
  //       return { startDate: null, endDate: null };
  //   }
  // };

  const getApiDateParams = () => {
    const start = filters.fromDate ? formatDateForApi(filters.fromDate) : null;
    const end = filters.toDate ? formatDateForApi(filters.toDate) : null;

    switch (filters.dateFilterType) {
      case 'after':
        return { fromDate: start, toDate: null };
      case 'before':
        return { fromDate: null, toDate: end };
      case 'between':
        return { fromDate: start, toDate: end };
      case 'exactly':
        return { fromDate: start, toDate: start };
      default:
        return { fromDate: null, toDate: null };
    }
  };

  return (
    <ReactModal
      isOpen={isOpen}
      ariaHideApp={false}
      onRequestClose={handleClose}
      style={{
        overlay: {
          backgroundColor: 'rgba(0,0,0,0.6)',
        },
        content: {
          borderRadius: '24px',
          margin: 'auto',
          width: '600px',
          height: '300px',
          padding: '30px',
          background: '#F3F4F8',
        },
      }}
    >
      <div style={{ position: 'relative' }}>
        <CloseIcon
          src={closeSvg}
          onClick={handleClose}
          style={{
            position: 'absolute',
            right: '0',
            top: '0',
            cursor: 'pointer',
          }}
        />

        <h3 style={{ marginBottom: '20px' }}>Process Pay</h3>

        <p style={{ fontSize: '16px', marginBottom: '40px' }}>
          You are about to process pay for <strong>{totalExpenses}</strong> expense(s).
          <br />
          Are you sure you want to continue?
        </p>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
          <RegularButton style={{ backgroundColor: '#fff', color: '#4948AC' }} onClick={handleClose}>
            Cancel
          </RegularButton>

          <RegularButton onClick={handleConfirm} disabled={processPay.isLoading}>
            Confirm
          </RegularButton>
        </div>
      </div>
    </ReactModal>
  );
};
